import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, CircularProgress, styled } from "@mui/material";

const WideDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "1000px",
    width: "80%",
  },
}));

export const AwaitActionDialog = ({ open, title }: { open: boolean; title: string }) => {
  return (
    <React.Fragment>
      <WideDialog open={open} keepMounted aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        </DialogContent>
        ;<DialogActions></DialogActions>
      </WideDialog>
    </React.Fragment>
  );
};
